import React, {useState, useEffect, useContext, useRef} from "react";
import {store} from '../../context/store';
import {functions} from "../../constants/common-functions";
import {colorFunctions} from "../../constants/colors";
import {childDashboardsUtilisation} from "../../constants/dashboards-children";
import {useHistory} from 'react-router-dom';
import backgroundImage from "../../../images/nationwidebackground.png";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import {GREY_BACKGROUND} from "../../constants/general-constants";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../../constants/general-constants";
import {PURPLE} from "../../constants/general-constants";
import AmChartDoughnutIndicator from "../../components/AmChartDoughnutIndicator";
import AmChartSimpleBar from "../../components/AmChartSimpleBar";
import AmChartSimpleColumn from "../../components/AmChartSimpleColumn";
import AmChartSimpleLine from "../../components/AmChartSimpleLine";
import UtilisationRoomTable from "../utilisation/components/UtilisationRoomTable";
import UtilisationRoomPanel from "../utilisation/components/UtilisationRoomPanel";
import UtilisationKpiBox from "../utilisation/components/UtilisationKpiBox";
import {useParams} from "react-router-dom";
import {JWT} from "../../constants/local-storage";
import DashboardSelector from "../../components/DashboardSelector";
import DashboardPhotoNavigatorNonStandard from "../../components/DashboardPhotoNavigatorNonStandard";
import {EMPTY_FILTER_BEAN} from "../../constants/filter-constants";

export default function UtilisationAllNonStandard(){
	
	const globalState = useContext(store);
	const {dispatch} = globalState;
	const history = useHistory();
	
	const refFacility = useRef(null);
	
	const [utilisationAvg, setUtilisationAvg] = useState(0);
	const [utilisationMax, setUtilisationMax] = useState(0);
	const [utilisationMin, setUtilisationMin] = useState(0);
	const [utilisationEfficiency, setUtilisationEfficiency] = useState(0);
	const [seats, setSeats] = useState(0);
	const [observations, setObservations] = useState(0);
	const [datePeak, setDatePeak] = useState("");
	const [dateMin, setDateMin] = useState("");
	const [dataByFacility, setDataByFacility] = useState([]);
	const [dataByGroup, setDataByGroup] = useState([]);
	const [dataByHour, setDataByHour] = useState([]);
	const [dataUtilisationByDate, setDataUtilisationByDate] = useState([]);
	const [dataUtilisationEfficiencyByDate, setDataUtilisationEfficiencyByDate] = useState([]);
	const [dataByFloor, setDataByFloor] = useState([]);
	const [dataBySpace, setDataBySpace] = useState([]);
	const [leftBarChartData, setLeftBarChartData] = useState([]);
	const [initialised, setInitialised] = useState(false);
	
	const [leftBarChartHeight, setLeftBarChartHeight] = useState("100px");
	
	const [displayRoomTable, setDisplayRoomTable] = useState("none");
	const [displayGroupChart, setDisplayGroupChart] = useState("flex");
	
	const [facility, setFacility] = useState({});
	
	const groupTypes = [
		{code:"GROUP_TYPE_CLASS_CR", name: "CR Class", urlExtension:"crclass"},
		{code:"GROUP_TYPE_SPACE_TYPE", name:"Space Type", urlExtension:"spacetype"}
	];
	const [groupType, setGroupType] = useState(groupTypes[0].code);
	
	
	const [filterBean, setFilterBean] = useState(EMPTY_FILTER_BEAN);
				
			const queryContext =
				    globalState?.state?.queryContext;
			
	const [facilityId, setFacilityId] = useState(-100);
	const [floorId, setFloorId] = useState(-100);
	const [floorZoneId, setFloorZoneId] = useState(-100);

	const [spaceId, setSpaceId] = useState(-100);

	const [spaceTypeId, setSpaceTypeId] = useState(-100);
	const [parentSpaceTypeId, setParentSpaceTypeId] = useState(-100);

	const [organisationId, setOrganisationId] = useState(-100);
	const [parentOrganisationId, setParentOrganisationId] = useState(-100);

	const [showCoreDayOnly, setShowCoreDayOnly] = useState(0);
	const [showDesksMeetings, setShowDesksMeetings] = useState(-100);
	
	const [classificationId, setClassificationId] = useState(-100);
	const [classificationItemId, setClassificationItemId] = useState(-100);
	
	const facilityIdParam =
	    parseInt(
	        useParams()["facilityId"],
	        10
	    );
		
		
		const getFilterBean = function()
		{
		    const filterBeanTemp = {};

		    filterBeanTemp.facilities =
		        facilityId !== "-100"
		            ? [parseInt(facilityId)]
		            : [];

		    filterBeanTemp.facilityExcludes = [];

		    filterBeanTemp.floors =
		        floorId !== "-100"
		            ? [parseInt(floorId)]
		            : [];

		    filterBeanTemp.floorExcludes = [];

		    filterBeanTemp.floorZones =
		        floorZoneId !== "-100"
		            ? [parseInt(floorZoneId)]
		            : [];

		    filterBeanTemp.floorZoneExcludes = [];

		    filterBeanTemp.spaces =
		        spaceId !== "-100"
		            ? [parseInt(spaceId)]
		            : [];

		    filterBeanTemp.spaceExcludes = [];

		    filterBeanTemp.spaceTypes =
		        parentSpaceTypeId !== "-100"
		            ? [parseInt(parentSpaceTypeId)]
		            : [];

		    filterBeanTemp.spaceTypeExcludes = [];

		    filterBeanTemp.spaceTypeSubs =
		        spaceTypeId !== "-100"
		            ? [parseInt(spaceTypeId)]
		            : [];
					
			filterBeanTemp.classificationExcludes = [];

			filterBeanTemp.classifications =
			    classificationId !== "-100"
			        ? [parseInt(classificationId)]
			        : [];

			filterBeanTemp.classificationItemExcludes = [];

			filterBeanTemp.classificationItems =
			    classificationItemId !== "-100"
			        ? [parseInt(classificationItemId)]
			        : [];
					
			return filterBeanTemp;
					
		}
		
		useEffect(() => {

		    setFloorId(-100);
		    setFloorZoneId(-100);
		    setSpaceId(-100);

		    setParentSpaceTypeId(-100);
		    setSpaceTypeId(-100);

		    setParentOrganisationId(-100);
		    setOrganisationId(-100);

		    setClassificationId(1);
		    setClassificationItemId(-100);

		    setShowCoreDayOnly(0);
		    setShowDesksMeetings(-100);

		    setFacilityId(facilityIdParam);

		    setTimeout(() => {

		        if (refFacility.current) {
		            refFacility.current.value = facilityIdParam;
		        }

		    }, 250);

		    setInitialised(true);

		}, [queryContext]);
	
	useEffect(() => {
		
		if (!initialised) {
		    return;
		}

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetaverage",
	        functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        populateUtilisationAvg
	    );

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetmax",
	        functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        populateUtilisationMax
	    );

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetmin",
	        functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        populateUtilisationMin
	    );

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetefficiency",
	        functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        populateUtilisationEfficiency
	    );

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetcapacity",
	        functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        populateSeats
	    );

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetobservations",
	        functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        populateObservations
	    );

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetdatemax",
	        functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        calculateDatePeak
	    );

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetdatemin",
	        functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        calculateDateMin
	    );

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetavgbyclassificationitem",
	        functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        populateDataByClassificationItem
	    );

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetavgbyhour",
	        functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        populateDataByHour
	    );

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetbydate",
	        functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        populateDataUtilisationByDate
	    );

	    if(spaceId !== -100){

	        setDisplayRoomTable("flex");
	        setDisplayGroupChart("none");

	    }
	    else{

	        setDisplayRoomTable("none");
	        setDisplayGroupChart("flex");

	    }

	    if(facilityId === -100){
			
	        functions.postFilterBeanAjax(
	            "/resolutionsoftwareplatform/utilisationgetavgbyfacility",
	            functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	            populateDataByFacility
	        );

	    }
	    else{
			
	        if(floorId === -100){

	            functions.postFilterBeanAjax(
	                "/resolutionsoftwareplatform/utilisationgetavgbyfloor",
	                functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	                populateDataByFloor
	            );

	        }
	        else{

	            if(spaceId === -100){

	                functions.postFilterBeanAjax(
	                    "/resolutionsoftwareplatform/utilisationgetavgbyspace",
	                    functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	                    populateDataBySpace
	                );

	            }

	        }

	    }

	}, [
		initialised,
	    facilityId,
	    floorId,
	    spaceId,
	    spaceTypeId,
	    parentSpaceTypeId,
	    organisationId,
	    parentOrganisationId,
	    showCoreDayOnly,
	    showDesksMeetings,
	    floorZoneId,
	    classificationId,
	    classificationItemId
	]);
	
	
	useEffect(() => {

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/utilisationgetefficiencyovertime",
	        functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	        populateUtilisationEfficiencyOverTime
	    );

	}, [dataUtilisationByDate]);
	
	
	useEffect(() => {

	    if(groupType === "GROUP_TYPE_CLASS_CR"){

	        functions.postFilterBeanAjax(
	            "/resolutionsoftwareplatform/utilisationgetavgbyclassificationitem",
	            functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	            populateDataByClassificationItem
	        );

	    }
	    else{

	        functions.postFilterBeanAjax(
	            "/resolutionsoftwareplatform/utilisationgetavgbyspacetype",
	            functions.buildPostBodyFilterBeanQueryContext(getFilterBean(), queryContext),
	            populateDataBySpaceType
	        );

	    }

	}, [

	    groupType,
	    facilityId,
	    floorId,
	    spaceId,
	    spaceTypeId,
	    parentSpaceTypeId,
	    organisationId,
	    parentOrganisationId,
	    showCoreDayOnly,
	    showDesksMeetings,
	    floorZoneId,
	    classificationId,
	    classificationItemId,
		filterBean, queryContext
	]);
	
	useEffect(() => {
		setLeftBarChartHeight((20*leftBarChartData.length + 100) + 'px');
	}, [leftBarChartData]);

	
	const populateSeats = (obj) => {
		setSeats(obj.returnDouble);
	};
	
	const populateObservations = (obj) => {
		setObservations(obj.returnDouble);
	};
	
	const populateUtilisationMax = (obj) => {
		let thisValue = obj.returnDouble;
		if(parseInt(thisValue) > 100){
			setUtilisationMax(100);
		}
		else{
			setUtilisationMax(obj.returnDouble);
		}
	};
	
	const populateUtilisationMin = (obj) => {
		setUtilisationMin(obj.returnDouble);
	};
	
	const populateUtilisationEfficiency = (obj) => {
		setUtilisationEfficiency(obj.returnDouble);
	};
	
	const populateUtilisationAvg = (obj) => {
		setUtilisationAvg(obj.returnDouble);
	};
	
	
	
	const calculateDatePeak = (input) => {
		
		if(input.returnDate){

	        setDatePeak(
	            input.returnDate.substring(0, 10)
	        );

	    }
	};
	
	const calculateDateMin = (input) => {
		if(input.returnDate){

	        setDateMin(
	            input.returnDate.substring(0, 10)
	        );

	    }
	};
	
	const populateSpaceTypes = (results) => {
		let tempSpaceTypes = [];
		for(let i=0; i<results.length; i++){
			tempSpaceTypes.push({
				id:results[i].id,
				name:results[i].code + ': ' + results[i].name
			});
		}
		//setSpaceTypes(tempSpaceTypes);
	};
	
	const populateDataByFacility = (results) => {
		let tempDataByFacility = [];
		for(let i=0; i<results.length; i++){
			tempDataByFacility.push({
				id:results[i].id,
				label:results[i].name,
				value:results[i].value
			});
		}
		setLeftBarChartData(tempDataByFacility);
		setDataByFacility(tempDataByFacility);
	};
	
	const populateDataByFloor = (results) => {
		let tempDataByFloor = [];
		for(let i=0; i<results.length; i++){
			tempDataByFloor.push({
				id:results[i].id,
				label:results[i].name,
				value:results[i].value
			});
		}
		setLeftBarChartData(tempDataByFloor);
		setDataByFloor(tempDataByFloor);
	};
	
	const populateDataBySpace = (results) => {
		
		let tempDataBySpace = [];
		for(let i=0; i<results.length; i++){
			tempDataBySpace.push({
				id:results[i].id,
				label:(results[i].code + ': ' + results[i].name),
				value:results[i].value
			});
		}
		setLeftBarChartData(tempDataBySpace);
		setDataBySpace(tempDataBySpace);
	};
	
	const populateDataByClassificationItem = (results) => {
		console.log("Classification Item Data");
		console.log(results);
		let tempDataByGroup = [];
		for(let i=0; i<results.length; i++){
			let labelString = results[i].name;
			if(labelString.length > 20){
				labelString = labelString.substring(0, 20) + '...';
			}
			tempDataByGroup.push({
				id:results[i].id,
				label:labelString,
				value:results[i].value
			});
		}
		setDataByGroup(tempDataByGroup);
	};
	
	const populateDataBySpaceType = (results) => {
		let tempDataByGroup = [];
		for(let i=0; i<results.length; i++){
			let labelString = results[i].code + ": " + results[i].name;
			if(labelString.length > 20){
				labelString = labelString.substring(0, 20) + '...';
			}
			tempDataByGroup.push({
				id:results[i].id,
				label:labelString,
				value:results[i].value
			});
		}
		setDataByGroup(tempDataByGroup);
	};
	
	const populateDataByHour = (results) => {
		let tempDataByHour = [];
		for(let i=0; i<results.length; i++){
			tempDataByHour.push({
				id:results[i].label,
				label:results[i].label,
				value:results[i].avg
			});
		}
		setDataByHour(tempDataByHour);
	};
	
	const populateDataUtilisationByDate = (results) => {
		
				
		let tempDataUtilisationByDate = [];
		for(let i=0; i<results.length; i++){
			tempDataUtilisationByDate.push({
				id:results[i].id,
				label:results[i].name,
				utilisation:parseInt(results[i].value)
			});
		}
		setDataUtilisationByDate(tempDataUtilisationByDate);
		
	};
	
	const populateUtilisationEfficiencyOverTime = (results) => {
		let tempDataUtilisationEfficiencyByDate = [];
		for(let i=0; i<results.length; i++){
			tempDataUtilisationEfficiencyByDate.push({
				label:results[i].groupBy,
				efficiency:results[i].returnDouble,
				utilisation:dataUtilisationByDate[i].utilisation
			})
		}
		setDataUtilisationEfficiencyByDate(tempDataUtilisationEfficiencyByDate);
	};
	
  
  const thisContainer = {
  	display:"flex",
  	position:"fixed",
  	flexDirection:"column",
  	width:"100%",
  	minheight:"100vh",
  	left:"0px",
  	top:"0px",
  	//backgroundColor:GREY_BACKGROUND
  };
  
  const mainContainer = {
  	display:"flex",
  	position:"fixed",
  	top:"0px",
  	left:"60px",
  	bottom:"0px",
  	right:"0px",
  	flexDirection:"column",
  	overflow:"auto"
  };
 
 	const topContainer ={
 		display:"flex",
 		height:"calc(100vh - 0px)",
 		width:"100%"
 	};
 	
 	const leftContainer ={
 		display:"flex",
 		flexDirection:"column",
 		width:"520px",
 		marginRight:"0px",
 		//borderRight:"2px solid #eee",
 		paddingTop:"0px",
 		backgroundColor:"#fff",
 		minHeight:"200vh",
 	};
 	
 	const rightContainer ={
 		display:"flex",
 		flexDirection:"column",
 		width:"calc(100% - 542px)",
		paddingTop:'60px'
 	};
 	
 	const rightTopContainer ={
 		display:"flex",
 		width:"100%",
 		height:"200px",
 		justifyContent:"space-between",
 	};
 	
 	const kpiContainer = {
 		display:"flex",
 		height:"100%",
 		width:"calc(50% - 20px)",
 		justifyContent:"space-around",
 		flexWrap:"wrap"
 	};
 	
 	const boxIndicatorContainer = {
 		display:"flex",
 		flexWrap:"wrap",
		width:"calc(50% - 20px)",
		height:"120px"
 	};
 	
 	const boxIndicator = {
 		display:"flex",
 		height:"30px",
 		borderRadius:"15px",
 		alignItems:"center",
 		marginBottom:"10px",
 		width:"calc(100% - 0px)"
 	};
 	
 	const boxIndicatorLabel = {
 		display:"flex",
 		width:"110px",
 		fontSize:"14px",
 		color:"white",
 		paddingLeft:"20px"
 	};
 	
 	const boxIndicatorFigure = {
 		display:"flex",
 		fontSize:"18px",
 		color:"white"
 	};

 	
 	const kpiDougnutContainer = {
 		display:"flex",
 		width:"33%",
 		height:"calc(100% - 40px)"	,
 		flexDirection:"column",
 		paddingTop:"20px"
 	};
 	
 	const kpiDoughnutTitle = {
 		display:"flex",
 		height:"10px",
 		width:"100%",
 		alignItems:"center",
 		justifyContent:"space-around",
 		fontSize:"14px",
 		fontWeight:"bold"
 	};
 	
 	const rightBottomContainer ={
 		display:"flex",
 		height:"300px",
 		width:"100%"
 	};
 	
 	const rightBottomLeftContainer ={
 		display:"flex",
 		backgroundColor:"teal",
 		width:"50%",
 		height:"300px",
 		flexDirection:"column"
 	};
 	
 	const rightBottomLeftTitle = {
 		display:"flex",
 		height:'30px',
 		color:"white",
 		justifyContent:"space-around",
		alignItems:"center"
 	};
 	
 	const rightBottomRightContainer ={
 		display:"flex",
 		width:"50%",
 		height:"calc(100% - 4px)",
 		flexDirection:"column",
 		border:"2px solid teal"
 	};
 	
 	const bottomContainer ={
 		display:"flex",
 		width:"100%",
 		height:"calc(100vh - 560px)",
 		flexDirection:"column",
 		minHeight:"300px"
 	}; 
 	
 	const clickFacility = (id) => {
 		refFacility.current.value = id;
 		setFacilityId(id);
 	};
 	
 	const clickSpace= (id) => {
 		
 		//refSpace.current.value = id;
 		setSpaceId(id);
 	};
 	
 	const clickFloor = (id) => {
 		//refFloor.current.value = id;
 		setFloorId(id);
 	};
 	
 	const dataByDateGraphs = [
 		{id:"utilisation", title:"Average Utilisation", keyColumn:"utilisation", color:"blue"},
 		{id:"efficiency", title:"Efficiency", keyColumn:"efficiency", color:"green"},
 	];
 	
 	const selectPanel = {
 		display:"flex",
 		height:"40px",
 		alignItems:"center",
 		marginLeft:"20px"
 	};
 	
 	const selectPanelLabel = {
 		display:'flex',
 		width:"140px",
 		color:"black",
 		fontSize:'12px',
 		fontWeight:"bold"
 	};
 	
 	const selectPanelSelect = {
 		display:'flex',
 		width:"200px",
 		height:"30px",
 		border:"1px solid lightgrey",
 		borderRadius:"5px",
 		paddingLeft:"10px",
 		fontSize:'12px'
 	};
	
	
	const overlay = {
		display:'flex',
		position:'fixed',
		left:'0px',
		right:'0px',
		top:'0px',
		bottom:'0px',
		backgroundColor:'rgba(255, 255, 255, 0.8)'
	};
 	
 
 	
 	const switchGrouping = (e) => {
 		setGroupType(e.target.value);
 	};
 	
 	const goSite = () => {
 		setFacilityId(-100);
 		setFloorId(-100);
 		setSpaceId(-100);
 	};
 	
 
 	const handleChangeFacility = (e) => {
		const value =
		        parseInt(e.target.value, 10);

		    setFacilityId(value);
 		if(e.target.value === -100){
 			setSpaceId(-100);
 			setFloorId(-100);
 		}
 	};
 	
 	const handleChangeFloor = (e) => {
		const value =
		        parseInt(e.target.value, 10);

		    setFloorId(value);
 		if(e.target.value === -100){
 			setSpaceId(-100);
 		}
 	};
 	
 	const handleChangeSpace = (e) => {
		const value =
				        parseInt(e.target.value, 10);
 		setSpaceId(value);
 	};
 	
 	const roomTableContainer = {
 		display:displayRoomTable,
 		width:"calc(100% - 40px)",
 		margin:"20px",
 		marginBottom:"100px",
 		minHeight:"600px"
 	};
 	
 	const roomInfoContainer = {
 		display:displayRoomTable,
 		width:"100%"
 	};
 	
 	const groupChartContainer ={
 		display:displayGroupChart,
 		width:"100%",
 		flexDirection:"column",
 		paddingTop:"10px",
 		height:"calc(100% - 20px)"
 	};
 	
 	const barChartContainer = {
 		display:'flex',
 		width:"100%",
 		marginTop:"20px",
 		minHeight:"200px"
 	};
 	
 	const handleBarClick = (id) => {
	 		if(facilityId === -100){
	 			clickFacility(id);
	 		}
	 		else{
	 			if(floorId === -100){
	 				clickFloor(id);
	 			}
	 			else{
	 				clickSpace(id);
	 			}
	 		}
 	};
 	
 	const groupTypeOptionDisplay = groupTypes.map((item, index) =>
 		<option value={item.code} style={{color:'black'}}>
 			{item.name}
 		</option>
 	);
 	
	return (
			<div style={thisContainer}>
				<div style={overlay}/>
				<Header transitionHide={true}/>
				<LeftMenu/>	
				<DashboardSelector
					title="Utilisation Dashboard"
					childDashboards={childDashboardsUtilisation}
				/>
				<div style={mainContainer}>
					<div style={topContainer}>
						<div style={leftContainer}>
							
						<DashboardPhotoNavigatorNonStandard

						    refFacility={refFacility}
						    facilityId={facilityId}
						    setFacilityId={setFacilityId}
						    floorId={floorId}
						    setFloorId={setFloorId}
						    spaceId={spaceId}
						    setSpaceId={setSpaceId}
						    classificationId={classificationId}
						    setClassificationId={setClassificationId}
						    classificationItemId={classificationItemId}
						    setClassificationItemId={setClassificationItemId}
						    spaceTypeId={spaceTypeId}
						    setSpaceTypeId={setSpaceTypeId}
						    filterBean={filterBean}
						/>
								
								<div style={barChartContainer}>
								 <AmChartSimpleBar
								 	chartId="utilisationallnonstandardleftbar"
								 	chartData={leftBarChartData}
								 	categoryKey="label"
								 	valueKey="value"
								 	width="100%"
								 	height={leftBarChartHeight}
									onClick={handleBarClick}
									/>
								</div>
								
							
						</div>
						<div style={rightContainer}>
							<div style={rightTopContainer}>
									<div style={kpiContainer}>
										<div style={kpiDougnutContainer}>
											<AmChartDoughnutIndicator
												id="utilisationallnonstandarddoughnutavg"
												percentage={utilisationAvg}
												width="120"
												height="120"
											/>
											<div style={kpiDoughnutTitle}>
												Avg Utilisation
											</div>
										</div>
										<div style={kpiDougnutContainer}>
											<AmChartDoughnutIndicator
												id="utilisationallnonstandarddoughnutmin"
												percentage={utilisationMax}
												width="120"
												height="120"
											/>
											<div style={kpiDoughnutTitle}>
												Max Utilisation
											</div>
										</div>
										<div style={kpiDougnutContainer}>
											<AmChartDoughnutIndicator
												id="utilisationallnonstandarddoughnutmax"
												percentage={utilisationEfficiency}
												width="120"
												height="120"
											/>
											<div style={kpiDoughnutTitle}>
												Efficiency
											</div>
										</div>
										
									</div>
									<div style={boxIndicatorContainer}>
										<UtilisationKpiBox
											title="Seats"
											figure={functions.formatNumber(seats, 0)}
											color="teal"
											width="calc(50% - 20px)"
										/>
										<UtilisationKpiBox
											title="Observations"
											figure={functions.formatNumber(observations, 0)}
											color="teal"
											width="calc(50% - 20px)"
										/>
										
										<UtilisationKpiBox
											title="Max On"
											figure={functions.formatDate(datePeak)}
											color="darkred"
											width="calc(50% - 20px)"
										/>
										
										<UtilisationKpiBox
											title="Min On"
											figure={functions.formatDate(dateMin)}
											color="darkred"
											width="calc(50% - 20px)"
										/>
									</div>
							</div>
							<div style={rightBottomContainer}>
								<div style={rightBottomLeftContainer}>
									<AmChartSimpleColumn
									 	chartId="utilisationallnonstandarddailyprofile"
									 	chartData={dataByHour}
									 	categoryKey="label"
									 	valueKey="value"
									 	color="white"
									 	width="100%"
									 	height="calc(100% - 30px)"
									 	whiteChart="yes"
										/>
										<div style={rightBottomLeftTitle}>
											Daily Profile
										</div>
								</div>
								<div style={rightBottomRightContainer}>
									<div style={roomInfoContainer}>
										<UtilisationRoomPanel
											roomId={spaceId}
											
										/>
									</div>
									<div style={groupChartContainer}>
										<AmChartSimpleColumn
										 	chartId="utilisationallnonstandardbreakdown"
										 	chartData={dataByGroup}
										 	categoryKey="label"
										 	valueKey="value"
										 	color="teal"
										 	width="100%"
										 	height="calc(100% - 20px)"
											/>
											<div style={{...selectPanel, marginLeft:'50px'}}>
												<div style={selectPanelLabel}>
													Show Utilisation By
												</div>
												<select style={selectPanelSelect} onChange={switchGrouping}>
													{groupTypeOptionDisplay}
												</select>
											</div>
										</div>
								</div>
							</div>
							<div style={bottomContainer}>
								<AmChartSimpleLine
									chartId="utilisationallnonstandardlinechart"
									width="100%"
									height="calc(100% - 30px)"
									chartData={dataUtilisationByDate}
									graphs={dataByDateGraphs}
									categoryKey="label"
								/>
								<div style={kpiDoughnutTitle}>
									Daily Utilisation
								</div>
							</div>
							<div style={roomTableContainer}>
								{/*<UtilisationRoomTable
									data={dataUtilisationByDate}
									roomId={spaceId}
									
								/>*/}
							</div>
						</div>
					</div>
					
				</div>
			</div>
	);
}